import React from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ErrorBar,
  Cell,
  LabelList,
} from 'recharts'
import { TChartRow } from 'types/models/DataAnalysis'

type Props = {
  data: TChartRow[]
  yUnit?: string
  height?: number
  colorByCode?: Record<string, string>
}

const ValueTooltip = ({
  active,
  payload,
  label,
  yUnit,
}: {
  active?: boolean
  payload?: any[]
  label?: string
  yUnit?: string
}) => {
  if (!active || !payload?.length) return null
  const v = payload[0]?.value as number
  const std = payload[0]?.payload?.std as number
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #ddd',
        padding: 8,
        borderRadius: 6,
      }}
    >
      <div>
        <strong>Wheat code:</strong> {label}
      </div>
      <div>
        <strong>Avg:</strong> {v.toFixed(3)}
        {yUnit ?? ''}
      </div>
      <div>
        <strong>Std dev:</strong> {std.toFixed(3)}
      </div>
    </div>
  )
}

export const MetricBarChart: React.FC<Props> = ({
  data,
  yUnit,
  height = 140,
  colorByCode,
}) => {
  return (
    <div style={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 18, right: 8, bottom: 16, left: 8 }}
          barGap={8}
        >
          <CartesianGrid vertical={false} strokeDasharray="3 3" />
          <XAxis
            dataKey="code"
            interval={0}
            tick={{ fontSize: 12 }}
            angle={data.length > 10 ? -35 : 0}
            textAnchor={data.length > 10 ? 'end' : 'middle'}
            dy={data.length > 10 ? 8 : 0}
            tickMargin={data.length > 10 ? 6 : 0}
          />
          <YAxis
            tick={{ fontSize: 13 }}
            axisLine={false}
            tickLine={false}
            width={50}
            tickFormatter={(value: number) => `${value}${yUnit ?? ''}`}
          />
          <Tooltip
            cursor={{ fill: '#f8f8f8' }}
            content={<ValueTooltip yUnit={yUnit} />}
          />
          <Bar dataKey="value" radius={[6, 6, 0, 0]} barSize={40}>
            {data.map((d, i) => (
              <Cell key={`cell-${d.code}-${i}`} fill={colorByCode?.[d.code]} />
            ))}
            <LabelList
              dataKey="value"
              position="top"
              formatter={(v: number) => Math.round(v).toFixed(0)}
              style={{ fontSize: 12, fill: '#333' }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
